export enum Types {
  CHANGE_SORT = "HR_LEAVE_ENTITLEMENT_TABLE_CHANGE_SORT",
}

export type Action = changeHrLeaveEntitlementsTableSortAction

export type changeHrLeaveEntitlementsTableSortAction = {
  payload: { sort: string[] }
  type: Types.CHANGE_SORT
}

export function changeSorting(sort: string[]): changeHrLeaveEntitlementsTableSortAction {
  return {
    payload: { sort },
    type: Types.CHANGE_SORT,
  }
}
